/**
 * Applies the theme by setting the data-theme attribute on the document element
 * @param {string} theme - The theme to apply ('light' or 'dark')
 */
export function applyTheme(theme = 'light') {
    document.documentElement.setAttribute('data-theme', theme);
}
